require ('./topBarCC.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { formatText, FormattedText } = require('core/i18n').i18n;
// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const LogoutModalCC = require('components/contactCenter/disasterRecovery/logoutModalCC/logoutModalCC');
//@constants
const { GAP_ACCESS_URL } = require('constants/contactCenter/gapUrl');
// @ helpers
const { clientLogoutDisasterRecovery, agentLogoutDisasterRecovery} = require('utilities/contactCenter/disasterRecoveryhelper');
// @ actions
const disasterRecoveryAgentTokenRenewalActions = require('actions/contactCenter/disasterRecoveryAgentTokenRenewal/disasterRecoveryAgentTokenRenewal');
const customerFinderActions = require('actions/contactCenter/customerFinder');

class TopBarCC extends React.Component {
    constructor(props){
        super(props);
        this.handleConfirmUserLogout = this.handleConfirmUserLogout.bind(this);
        this.handleUserLogout = this.handleUserLogout.bind(this);
        this.handleNewClient = this.handleNewClient.bind(this);
        this.handleN2 = this.handleN2.bind(this);
        this.closeConfirmUserLogoutModal = this.closeConfirmUserLogoutModal.bind(this);
        this.state = {
            isOpen: false
        }
    }

    handleConfirmUserLogout(){
        this.setState({
            isOpen: true
        })
    }

    handleNewClient () {
        const { endInteraction, history } = this.props;

        endInteraction();
        clientLogoutDisasterRecovery(history);
    }

    handleUserLogout() {
        const {
            changeOfficeValidation,
            history,
            immAgentLogin,
            stopAgentTokenRenewalTimer,
            endInteraction
        } = this.props;

        this.closeConfirmUserLogoutModal();
        if(immAgentLogin.get('inOffice')){
            changeOfficeValidation();
        }
        stopAgentTokenRenewalTimer();
        agentLogoutDisasterRecovery(history);
        endInteraction();
    }

    handleN2(){
        this.props.history.push(GAP_ACCESS_URL);
    }

    closeConfirmUserLogoutModal(){
        this.setState({
            isOpen: false
        })
    }

    getBtn(evtHandler, txtSelector, disabled=false){
        return (
            <div className="container-topbarcc__new-client">
                <OKButton modifier="ghost-inverse" size="small" onClick={evtHandler} disabled={disabled}>
                    <FormattedText value={txtSelector} />
                </OKButton>
            </div>
        );
    }

    render() {
        const { securityLevel, immRaiseToN2, allowMenu} =  this.props;
        const title = formatText('navBarDisaster-title');
        const securityLevelMod = (immRaiseToN2.getIn(['response','status']) === 'OK') ? immRaiseToN2.getIn(['response','level']) : securityLevel;
        const labelSecurity = securityLevel && allowMenu ? `${formatText('navBarDisaster-labelSecurity')} ${securityLevelMod}` : '';
        const newClientBtn = securityLevel  && allowMenu  && this.getBtn(this.handleNewClient,'navBarDisaster-newClient');
        const raiseN2BtnDisabled = (securityLevelMod === 'N2');
        const raiseToN2 = securityLevel  && allowMenu  && this.getBtn(this.handleN2,'navBarDisaster-n2',raiseN2BtnDisabled);
        let { isOpen } = this.state;

        return (
            <div className="container-topbarcc">
                <div className="container-topbarcc__title">
                    {title}
                </div>
                <div className="container-topbarcc__right-buttons">
                    {newClientBtn}
                    {raiseToN2}
                    <div className="container-topbarcc__security-level">
                        {labelSecurity}
                    </div>
                    <div className="container-topbarcc__exit">
                        <OKButton modifier="ghost-inverse" size="small" onClick={this.handleConfirmUserLogout}>
                            <FormattedText value="navBarDisaster-exit" />
                        </OKButton>
                    </div>
                </div>
                <LogoutModalCC
                    closeModal={this.closeConfirmUserLogoutModal}
                    isOpen={isOpen}
                    onUserLogout={this.handleUserLogout}
                />
            </div>
        );
    }
}

TopBarCC.propTypes = {
    allowMenu: PropTypes.bool,
    changeOfficeValidation: PropTypes.func.isRequired,
    endInteraction: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAgentLogin: PropTypes.object.isRequired,
    immRaiseToN2: PropTypes.object,
    securityLevel: PropTypes.string,
    stopAgentTokenRenewalTimer: PropTypes.func.isRequired,
};

TopBarCC.defaultProps = {
    securityLevel: '',
    endInteraction: () => {}
}

module.exports = connect(state => ({
    immRaiseToN2: state.raiseToN2,
}), {
    stopAgentTokenRenewalTimer: disasterRecoveryAgentTokenRenewalActions.stopAgentTokenRenewalTimer,
    endInteraction: customerFinderActions.endInteraction
})(withRouter(TopBarCC));
